import "./App.css";
import Api from "./Components/Api";

function App() {
  return (
    <div className="App">
      <Api />
    </div>
  );
}

export default App;
